import {ITableDataEntryValue} from "./interfaces";

export function GetTime(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'TIME',
        value: ''
    };
}

export function GetUsersignature(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'USER_SIGNATURE',
        value: {
            id: 0,
            display: '',
            signed: false
        }
    };
}

export function GetDatetime(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'DATETIME',
        value: ''
    };
}

export function GetDouble(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'DOUBLE',
        value: 0.0
    };
}

export function GetLong(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'LONG',
        value: 0
    };
}

export function GetString(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'STRING',
        value: ''
    };
}

export function GetTimespan(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'TIMESPAN',
        value: {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        }
    };
}

export function GetForeignKey(): ITableDataEntryValue {
    return {
        referenceName: '',
        type: 'FOREIGN_KEY',
        value: ''
    };
}

// TODO Write all default column attributes if not found in data

// TODO should some map or smf